import * as React from 'react';
import { styled, alpha } from '@mui/material/styles';
import Button from '@mui/material/Button';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import EditIcon from '@mui/icons-material/Edit';
import Divider from '@mui/material/Divider';
import ArchiveIcon from '@mui/icons-material/Archive';
import FileCopyIcon from '@mui/icons-material/FileCopy';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { Box } from '@mui/material';
import {Link} from 'react-router-dom'
import LockResetIcon from '@mui/icons-material/LockReset';
import LogoutIcon from '@mui/icons-material/Logout';
import { Navigate } from 'react-router-dom';

import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { crtCapitalUser } from '../constants/helpers';




const StyledMenu = styled((props) => (
  <Menu
    elevation={0}
    anchorOrigin={{
      vertical: 'bottom',
      horizontal: 'right',
    }}
    transformOrigin={{
      vertical: 'top',
      horizontal: 'right',
    }}
    {...props}
  />
))(({ theme }) => ({
  '& .MuiPaper-root': {
    borderRadius: 6,
    marginTop: theme.spacing(1),
    minWidth: 180,
    color:
      theme.palette.mode === 'light' ? 'rgb(55, 65, 81)' : theme.palette.grey[300],
    boxShadow:
      'rgb(255, 255, 255) 0px 0px 0px 0px, rgba(0, 0, 0, 0.05) 0px 0px 0px 1px, rgba(0, 0, 0, 0.1) 0px 10px 15px -3px, rgba(0, 0, 0, 0.05) 0px 4px 6px -2px',
    '& .MuiMenu-list': {
      padding: '4px 0',
    },
    '& .MuiMenuItem-root': {
      '& .MuiSvgIcon-root': {
        fontSize: 18,
        color: theme.palette.text.secondary,
        marginRight: theme.spacing(1.5),
      },
      '&:active': {
        backgroundColor: alpha(
          theme.palette.primary.main,
          theme.palette.action.selectedOpacity,
        ),
      },
    },
  },
}));

export default function UserDropDown() {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [openDialog, setOpenDialog] = React.useState(false);

  const handleClickOpenDialog = () => {
    setAnchorEl(null);
    setOpenDialog(true);
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
  };


  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const userLogout = () => {
    localStorage.removeItem('user');
    window.location.replace('/data2/login')
  };

  return (
    <>
      <div>
      
      <Dialog
        open={openDialog}
        onClose={handleCloseDialog}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {"Logout?"}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Are you sure want to logout!
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button size="small" variant='contained'  color="success" onClick={userLogout} autoFocus>
            Yes
          </Button>
          <Button size="small" variant='contained'  color="error" onClick={handleCloseDialog}>No</Button>
        </DialogActions>
      </Dialog>
    </div>

    
    <div>
    
      <Box
        id="demo-customized-button"
        aria-controls={open ? 'demo-customized-menu' : undefined}
        aria-haspopup="true"
        aria-expanded={open ? 'true' : undefined}
        variant="contained"
        disableElevation
        onClick={handleClick}
        endIcon={<KeyboardArrowDownIcon />}
      >
        <img src="https://omkaradata.in/data/assets/images/users/1.jpg" alt="user" style={{ borderRadius:'50%', cursor:'pointer', marginLeft:'0.5rem' }} width="31" />
      </Box>
      <StyledMenu
        id="demo-customized-menu"
        MenuListProps={{
          'aria-labelledby': 'demo-customized-button',
        }}
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
      >
        <MenuItem onClick={handleClose} disableTouchRipple disableRipple sx={{ cursor:'disallow' }}>
          {/* <EditIcon /> */}
          <b>Welcome {crtCapitalUser?.UserNAme ? crtCapitalUser?.UserNAme : ((crtCapitalUser?.userInfo && crtCapitalUser?.userInfo.length > 0 && crtCapitalUser?.userInfo[0]) ? crtCapitalUser?.userInfo[0].UserName : null)}!
            
            </b>
        </MenuItem>
        
        <Divider sx={{ my: 0.5 }} />

        {/* <MenuItem onClick={handleClose} disableRipple>
          <EditIcon />
          Edit Profile
        </MenuItem> */}

        <MenuItem onClick={handleClose} disableRipple component={'a'} href="/data2/reset-password" >
          <LockResetIcon />
          Reset Password
        </MenuItem>
         
        
        <Divider sx={{ my: 0.5 }} />
        
        <MenuItem onClick={handleClickOpenDialog} disableRipple>
        {/* <MenuItem disableRipple> */}
          <LogoutIcon />
          Logout
        </MenuItem>
      </StyledMenu>
    </div>
    
    </>
  );
}
